import { Endpoint } from '../endpoint';
import { TaskStatusResponse, TaskStatusId } from '@business/entities/task_status';

export function fetchTaskStatuses() {
  return Endpoint.get<TaskStatusResponse[]>(`@makh/task-status`);
}

export function fetchTaskStatus(id: TaskStatusId) {
  return Endpoint.get<TaskStatusResponse[]>(`@makh/task-status/${id}`);
}

export function updateTaskStatus(id: TaskStatusId, data: Partial<TaskStatusResponse>) {
  return Endpoint.patch<TaskStatusResponse[]>(`@makh/task-status/${id}`, { data });
}

export function createTaskStatus(data: Partial<TaskStatusResponse>) {
  return Endpoint.post<TaskStatusResponse[]>(`@makh/task-status`, { data });
}

export function deletTaskStatus(id: TaskStatusId) {
  return Endpoint.delete<TaskStatusResponse[]>(`@makh/task-status/${id}`);
}

// export function sortTaskStatus(ids: string[]) {
//   return Endpoint.post<TaskStatusResponse[]>(`@makh/task-status/sort-task-status`, { data: { ids } });
// }
